import { getProfileInfo } from 'api/profilepage';
import { useAuthQuery } from 'hooks/useAuthQuery';

export const useProfileData = () => {
  const { isLoading, data } = useAuthQuery('profileDetails', getProfileInfo);

  return {
    isLoading,
    data,
  };
};
